import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonAvatar } from '@ionic/angular/standalone';
import { PublisherViewModel } from 'src/app/models/publisher.model';

@Component({
  selector: 'app-publisher-avatar',
  templateUrl: './publisher-avatar.component.html',
  styleUrls: ['./publisher-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonAvatar]
})
export class PublisherAvatarComponent {
  @Input() publisher: PublisherViewModel;

  get initials(): string {
    if (this.publisher !== undefined) {
      return this.publisher.forename.charAt(0).toUpperCase() + this.publisher.surname.charAt(0).toUpperCase();
    } else {
      return 'U';
    }
  }
}
